import { FunctionComponent } from 'react';

import { useCurrentUser } from '@savgroup-front-common/core/domains/login/useLoginStore';

import { useAppContext } from '@/view/app/App.context';

import HeaderProfileRoles from './HeaderProfileRoles';
import useStore from './hooks/useStore';
import messages from './messages';

const HeaderProfileUserName: FunctionComponent = () => {
  const {
    firstname: firstName,
    lastname: lastName,
    mail: email,
    roles: roleNames,
    profiles: profileNames,
  } = useCurrentUser();

  const storeNames = useStore();
  const { selectedSeller } = useAppContext();

  const fullName =
    firstName.length || lastName.length ? `${firstName} ${lastName}` : email;

  return (
    <div className="flex flex-col gap-0.5">
      <p className="truncate text-base font-semibold stext-base-default">
        {fullName}
      </p>
      {profileNames.length === 0 && roleNames.length > 0 && (
        <HeaderProfileRoles message={messages.roles} list={roleNames} />
      )}
      {profileNames.length > 0 && (
        <HeaderProfileRoles message={messages.profiles} list={profileNames} />
      )}
      {storeNames.length > 0 && (
        <HeaderProfileRoles message={messages.stores} list={storeNames} />
      )}
      {selectedSeller && (
        <HeaderProfileRoles
          message={messages.seller}
          list={[selectedSeller.name]}
        />
      )}
    </div>
  );
};

export default HeaderProfileUserName;
